<radar-chart-tag>
    <slot/>
    <script>
        import radarChart from '@croco/radar-chart';

        export default {
            onMounted(props, state) {
                let width  = (typeof props.width !== 'undefined') ?  props.width : 250
                let height = (typeof props.height !== 'undefined') ?  props.height : 250
                let data   = (typeof props.data !== 'undefined') ?  props.data : null

                radarChart.draw(this.root, data, {
                    w: width,
                    h: height,
                    maxValue: 71.98197841644287,
                    levels: 6,
                    ExtraWidthX: width + 50
                })

            }
        }
    </script>
</radar-chart-tag>
